import styled from 'styled-components'

export const StyledCommissionsTable = styled.div`
  position: relative;
  width: 100%;
`

export const StyledCommissionsFooter = styled.div`
  position: relative;
  margin-top: 1rem;
`

export const StyledTable = styled.div`
  margin-bottom: 2rem;
`

export const StyledFilters = styled.div`
  margin-top: 1rem;
`

export const StyledActionsContainer = styled.div`
  display: flex;
  gap: 1rem;
`
